import { useForm } from "react-hook-form";
import BackDrop from "../../../components/ui/BackDrop";
import { cn } from "../../../utils/twMerge";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import { closeIcon } from "../../../assetData/icons";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";
import SearchableDropdown from "../../ui/tableDataDropdowns/SearchableDropdown";

const AddTemplateBrokerMapping = ({
  data,
  buttonConfig,
  buttonClicked,
  brokerData,
  brokerLoading,
}) => {
  const addHandler = buttonConfig.addHandler;
  const closeHandler = buttonConfig.closePopup;

  const filter =
    data?.sort((a, b) => b.template_id - a.template_id)?.at(0)?.template_id ||
    0;
  console.log("filter:::", filter);

  const schema = z.object({
    template_id: z.string().nonempty(),
    software_vendor_name: z.string().nonempty(),
    file_format: z.string().nonempty(),
    broker_id: z.number(),
  });

  const form = useForm({
    defaultValues: {
      template_id: String(filter + 1),
      software_vendor_name: "",
      file_format: "",
      broker_id: "",
    },
    resolver: zodResolver(schema),
  });

  const errors = form.formState.errors;

  const onSubmit = async (data) => {
    const res = await addHandler(data);
  };

  const onClose = () => {
    closeHandler();
  };

  const handleKey = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  return (
    <>
      <div className="fixed left-1/2 z-50 mx-auto min-h-[300px] w-[98%] max-w-[700px] -translate-x-1/2 rounded bg-white p-8 max-lg:top-[30%] max-sm:top-[10%] lg:top-1/2 lg:-translate-y-1/2">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">
          Add Template Broker Mapping
        </h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="w-full pr-2 max-lg:max-h-[550px] lg:max-h-[400px] ">
            {/* row 1 */}
            <div className="gap-2 sm:flex max-sm:[&>div]:mt-4">
              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">Template ID*</label>
                <input
                  placeholder="Type here"
                  type="number"
                  {...form.register("template_id")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.template_id && "border-[1px] border-red-300",
                  )}
                  onWheel={(e) => e.target.blur()}
                  onKeyDown={handleKey}
                />
              </div>

              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">Broker Name*</label>
                <SearchableDropdown
                  data={brokerData}
                  valueKey={"id"}
                  displayKey={"name"}
                  filterKey={"id"}
                  setFilter={(val) => {
                    form.setValue("broker_id", val);
                  }}
                  label={"Broker Name"}
                  type={"searchable"}
                  loading={brokerLoading}
                  className={"fixed z-[9999]"}
                />
              </div>
            </div>

            {/* row 2 */}
            <div className="gap-2 sm:mt-8 sm:flex max-sm:[&>div]:mt-4">
              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">File Format*</label>
                <select
                  {...form.register("file_format")}
                  className={cn(
                    "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.file_format && "border-[1px] border-red-300",
                  )}
                >
                  <option value="">Select</option>
                  <option value="CSV">CSV</option>
                  <option value="HTML">HTML</option>
                  <option value="pdf">PDF</option>
                  <option value="EXCEL">XLSX</option>
                  <option value="Zip">ZIP</option>
                </select>
              </div>

              <div className={cn("flex w-full flex-col  gap-2")}>
                <label className="text-base text-[#636363]">Vendor Name</label>
                <input
                  type="text"
                  step="any"
                  {...form.register("software_vendor_name")}
                  placeholder="Type here"
                  className={cn(
                    "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                    errors.software_vendor_name &&
                      "border-[1px] border-red-300",
                  )}
                />
              </div>
            </div>
          </div>

          <div className="flex items-end justify-between gap-2 sm:[&>button]:w-1/3">
            <button
              type="submit"
              disabled={buttonClicked}
              className={` ${
                buttonClicked ? "opacity-[70%]" : ""
              } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-16 py-2 font-semibold text-white `}
            >
              {buttonClicked ? <MirageLoader /> : "ADD"}
            </button>
            <button className="max-lg:hidden"></button>
            <button className="max-lg:hidden"></button>
          </div>
        </form>
      </div>
      <BackDrop closeHandler={closeHandler} />
    </>
  );
};

export default AddTemplateBrokerMapping;
